module.exports = __webpack_public_path__ + "img/step_3.91c27283.svg";